import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Capacitor } from '@capacitor/core'
import { SafeArea } from '@capacitor-community/safe-area'
import App from './App.tsx'
import './index.css'

// Initialize SafeArea plugin on native platforms
// NOTE: customColorsForSystemBars is FALSE - let native MainActivity.java handle status bar colors
// This prevents conflicts between JavaScript and native Android status bar control
if (Capacitor.isNativePlatform()) {
  // @ts-expect-error - SafeArea plugin API may vary by version
  SafeArea.enable?.({
    config: {
      customColorsForSystemBars: false,  // Let native Android code control status bar
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)
